import { render, staticRenderFns } from "./rightMessage.vue?vue&type=template&id=c63fbaf6&scoped=true"
import script from "./rightMessage.vue?vue&type=script&lang=js"
export * from "./rightMessage.vue?vue&type=script&lang=js"
import style0 from "./rightMessage.vue?vue&type=style&index=0&id=c63fbaf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63fbaf6",
  null
  
)

export default component.exports